import React from "react";
import MainLayout from "./MainLayout";
import BasicInfo from "../common/OnBoarding/OnBoardingBasicInfo";

const BasicInfoPage = (props) => <MainLayout component={BasicInfo} />;

export default BasicInfoPage;
